export default "__VITE_ASSET__148f5869__"